import firebase from "firebase/app";
import "firebase/auth";
import UsersColl from "../firebase/UsersColl";

export const TOKEN_KEY = "userInfo";

export const login = (email, password) => {
  if (isLogin()) {
    return true;
  }

  return firebase
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((response) => {
      var user = response.user;
      if (!user.emailVerified) {
        return firebase
          .auth()
          .signOut()
          .then(() => {
            throw new Error("EMAIL_NOT_VERIFIED");
          });
      }
      return UsersColl.shared.getUser(user.uid).then((fireUser) => {
        console.log(fireUser);
        localStorage.setItem(TOKEN_KEY, JSON.stringify(fireUser));
        return true;
      });
    });
};

export const logout = () => {
  return firebase
    .auth()
    .signOut()
    .then(() => {
      localStorage.removeItem(TOKEN_KEY);
    });
};

export const isLogin = () => {
  if (localStorage.getItem(TOKEN_KEY)) return true;
  else return false;
};

export const resendVerificationEmail = () => {
  const user = firebase.auth().currentUser;
  if (user) {
    return user
      .sendEmailVerification()
      .then(() => {
        alert("Verification email has been resent. Please check your inbox.");
        return true;
      })
      .catch((error) => {
        console.error("Error sending verification email:", error);
        alert("Failed to send verification email. Please try again later.");
        return false;
      });
  }
  return Promise.resolve(false);
};
